import type { ReactNode } from "react"

interface FeatureCardProps {
	icon: ReactNode
	title: string
	description: string
}

export function FeatureCard({ icon, title, description }: FeatureCardProps) {
	return (
		<div className="p-8 rounded-3xl border border-white/40 dark:border-sky-100/10 bg-white/60 dark:bg-black/20 backdrop-blur-md shadow-[0_4px_20px_-2px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_30px_-5px_rgba(14,165,233,0.1)] hover:bg-white/80 dark:hover:bg-black/40 transition-all duration-300 group">
			<div className="mb-6 p-3 bg-sky-100/50 dark:bg-sky-900/30 rounded-2xl inline-block text-sky-800 dark:text-sky-200 group-hover:bg-sky-200/50 dark:group-hover:bg-sky-800/50 transition-colors">
				{icon}
			</div>
			<h3 className="text-xl font-bold mb-3 text-sky-950 dark:text-sky-50">{title}</h3>
			<p className="text-lg text-sky-900/70 dark:text-sky-200/60 leading-relaxed">{description}</p>
		</div>
	)
}
